import { render, staticRenderFns } from "./WeeklyTask.vue?vue&type=template&id=bf14a22c&scoped=true"
import script from "./WeeklyTask.vue?vue&type=script&lang=js"
export * from "./WeeklyTask.vue?vue&type=script&lang=js"
import style0 from "./WeeklyTask.vue?vue&type=style&index=0&id=bf14a22c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf14a22c",
  null
  
)

export default component.exports